import {
  getAllPlaceMediaForWindowByPlaceId,
  getAllPlacesWithReviewsByPlaceId,
} from "@/api/places";

import { addDistanceToPlaces } from "./place-results";

export const SELECTED_PLACE_VIEW_ZOOM = 17;

const hasUsableMediaPath = (media) =>
  Boolean(
    media?.mediaPath ||
      media?.filePath ||
      media?.placeholderPath ||
      media?.thumbnailPath ||
      media?.mediumPath ||
      media?.largePath
  );

export const getPrimaryPlaceMedia = (mediaRecords) => {
  if (!Array.isArray(mediaRecords)) return [];

  const placeMedia = mediaRecords.filter(
    (media) => media?.type !== "menu" && hasUsableMediaPath(media)
  );

  return placeMedia.length > 0
    ? placeMedia
    : mediaRecords.filter(hasUsableMediaPath);
};

export const getSelectedPlaceWithMedia = async (placeId, userId) => {
  const [selectedPlace, mediaRecords] = await Promise.all([
    getAllPlacesWithReviewsByPlaceId(placeId, userId),
    getAllPlaceMediaForWindowByPlaceId(placeId).catch(() => []),
  ]);

  if (!selectedPlace) return null;

  const placeMedia = Array.isArray(selectedPlace?.placeMedia)
    ? selectedPlace.placeMedia
    : [];
  const fallbackMedia = getPrimaryPlaceMedia(mediaRecords);

  return {
    ...selectedPlace,
    placeMedia: placeMedia.length > 0 ? placeMedia : fallbackMedia,
  };
};

export const getSelectedPlaceCenter = (place) => {
  const lat = Number(place?.latitude);
  const lng = Number(place?.longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return { lat, lng };
};

export const buildSelectedPlaceViewState = ({
  selectedPlace,
  userLocation = null,
} = {}) => {
  const selectedPlaces = selectedPlace ? [selectedPlace] : [];
  const places = userLocation
    ? addDistanceToPlaces(selectedPlaces, userLocation, userLocation)
    : selectedPlaces;

  return {
    places,
    totalPlaces: places.length,
    center: getSelectedPlaceCenter(places[0]),
    zoom: SELECTED_PLACE_VIEW_ZOOM,
  };
};

export const loadSelectedPlaceViewState = async ({
  placeId,
  userId,
  userLocation,
}) => {
  const selectedPlace = await getSelectedPlaceWithMedia(placeId, userId);

  return buildSelectedPlaceViewState({
    selectedPlace,
    userLocation,
  });
};
